
import TheSnackbarQueueHandler from "@/components/TheSnackbarQueueHandler.vue";
import { switchLanguage } from "@/plugins/i18n/localeSwitcher";
import TheConfirmationDialog from "@/components/TheConfirmationDialog.vue";

export default {
  components: { TheConfirmationDialog, TheSnackbarQueueHandler },
};
